import Logo from '../logos/aerosim';

export default Logo;
